import { useContext } from 'react';
import { UserContext } from 'contexts/UserContext';

export function useUser() {
  const state = useContext(UserContext);
  return state;
}
